import React, { useEffect, useState } from "react";
import toast from "react-hot-toast";
import { authApiService } from "../../api/api";
import FilterBlock from "../../components/FilterBlock/FilterBlock";
import AddCategoryModal from "../../components/modals/AddCategoryModal/AddCategoryModal";
import EditCategoryModal from "../../components/modals/EditCategoryModal/EditCategoryModal";
import Pagination from "../../components/pagination/Pagination/Pagination";
import CategoriesTable from "../../components/Tables/CategoriesTable";
import TableTitle from "../../components/TableTitle/TableTitle";
import { ICategory, ICategoryOrderUpdateDto } from "../../types/category.type";
import { usersPerPage } from "../../utils/constants/page";
import { filterCategories } from "../../utils/filterUsers";
import styles from "./styles.module.scss";

const CategoriesPage: React.FC = () => {
  const [categories, setCategories] = useState<ICategory[]>([]);
  const [filteredCategories, setFilteredCategories] = useState<ICategory[]>([]);
  const [editSelectedCategory, setEditCategory] = useState<ICategory | null>(
    null
  );
  const [visibleCategories, setVisibleCategories] = useState<ICategory[]>([]);
  const [activePage, setActivePage] = useState<number>(1);
  const [totalPages, setTotalPages] = useState<number>(1);
  const [searchValue, setSearchValue] = useState<string>("");
  const [isAddCategory, setIsAddCategory] = useState<boolean>(false);
  const [isInfoModal, setInfoModal] = useState<boolean>(false);

  const getProductTypes = async () => {
    try {
      const results = await authApiService.getAllCategories();

      return results;
    } catch (err) {
      console.error(err);
    }
  };

  const updateCategoriesOrder = async (
    categoriesOrder: ICategoryOrderUpdateDto[]
  ) => {
    try {
      const updatedCategories = await authApiService.updateCategoriesOrder(
        categoriesOrder
      );
      if (updatedCategories) {
        // Сортуємо оновлені категорії за полем order
        const sortedCategories = [...updatedCategories].sort((a, b) => {
          if (a.order !== undefined && b.order !== undefined) {
            return a.order - b.order;
          }
          if (a.order !== undefined) return -1;
          if (b.order !== undefined) return 1;
          return 0;
        });
        setCategories(sortedCategories);
        getFiltredCategories(sortedCategories);
        toast.success("Порядок категорій оновлено");
      }
    } catch (err: any) {
      console.error(err);
      toast.error(
        err.response?.data?.message || "Помилка при оновленні порядку категорій"
      );
      // У разі помилки перезавантажуємо дані з сервера
      const resp = await getProductTypes();
      if (resp) {
        const sortedData = [...resp].sort((a, b) => {
          if (a.order !== undefined && b.order !== undefined) {
            return a.order - b.order;
          }
          if (a.order !== undefined) return -1;
          if (b.order !== undefined) return 1;
          return 0;
        });
        setCategories(sortedData);
        getFiltredCategories(sortedData);
      }
    }
  };

  const moveCategory = (index: number, direction: "up" | "down") => {
    // Отримуємо категорію з видимих (пагінованих)
    const categoryToMove = visibleCategories[index];
    if (!categoryToMove) return;

    // Знаходимо індекс цієї категорії в повному списку категорій
    const fullIndex = categories.findIndex(
      (cat) => cat.id === categoryToMove.id
    );
    if (fullIndex === -1) return;

    // Обчислюємо новий індекс
    const swapIndex = direction === "up" ? fullIndex - 1 : fullIndex + 1;

    // Перевіряємо межі
    if (swapIndex >= 0 && swapIndex < categories.length) {
      const newCategories = [...categories];
      [newCategories[fullIndex], newCategories[swapIndex]] = [
        newCategories[swapIndex],
        newCategories[fullIndex],
      ];

      // Підготувати дані для API: масив об'єктів з id та order для ВСІХ категорій
      const categoriesOrder: ICategoryOrderUpdateDto[] = newCategories.map(
        (category, idx) => ({
          id: category.id,
          order: idx + 1,
        })
      );

      updateCategoriesOrder(categoriesOrder);
    }
  };
  const changeVisibiltyProductTypes = (types: ICategory[]) => {
    const indexOfLastUser = activePage * usersPerPage;
    const indexOfFirstUser = indexOfLastUser - usersPerPage;
    if (types) {
      const changedTypes = types.slice(indexOfFirstUser, indexOfLastUser);
      setVisibleCategories(changedTypes);
    }
  };

  const getOptionsFilter = () => {
    let filteredCategories = [...categories];
    // setRole(role);

    // if (role.value !== EmployeeType.NONE) {
    //   filteredUsers = filteredUsers.filter((user) => user.role === role.value);
    // }

    return filteredCategories;
  };

  const getFiltredCategories = (tags: ICategory[]) => {
    const data = getOptionsFilter();
    const filtered = filterCategories(data, searchValue);
    setFilteredCategories(filtered);
  };

  const onClickApplyModal = async () => {
    const resp = await getProductTypes();
    if (resp) {
      // Сортуємо категорії за полем order, якщо воно є
      const sortedData = [...resp].sort((a, b) => {
        if (a.order !== undefined && b.order !== undefined) {
          return a.order - b.order;
        }
        if (a.order !== undefined) return -1;
        if (b.order !== undefined) return 1;
        return 0;
      });
      setCategories(sortedData);
      getFiltredCategories(sortedData);
    }
  };

  useEffect(() => {
    setTotalPages(Math.ceil(filteredCategories.length / usersPerPage));
  }, [filteredCategories]);

  useEffect(() => {
    getFiltredCategories(categories);
    // setActivePage(1);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [searchValue, categories]);

  useEffect(() => {
    (async () => {
      const data = await getProductTypes();
      if (data) {
        // Сортуємо категорії за полем order, якщо воно є
        const sortedData = [...data].sort((a, b) => {
          if (a.order !== undefined && b.order !== undefined) {
            return a.order - b.order;
          }
          if (a.order !== undefined) return -1;
          if (b.order !== undefined) return 1;
          return 0;
        });
        setCategories(sortedData);
      }
    })();
  }, []);

  useEffect(() => {
    changeVisibiltyProductTypes(filteredCategories);
    // setTotalPages(Math.ceil(users.length / usersPerPage));
    if (activePage > totalPages) {
      if (activePage === 1) {
        setActivePage(1);
      } else {
        setActivePage(totalPages);
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [activePage, categories, totalPages, filteredCategories]);
  return (
    <main className={styles.container}>
      <div className={styles.header}>
        <TableTitle title="Всього" count={categories?.length || 0} />
        <div>
          <FilterBlock
            searchValue={searchValue}
            onSearchChange={(value) => setSearchValue(value)}
            onPressAdd={() => setIsAddCategory(true)}
            addButtonTitle="Додати"
          />
        </div>
      </div>
      <CategoriesTable
        categories={visibleCategories}
        callBackInfo={setInfoModal}
        callBackEdit={setEditCategory}
        onClickRow={moveCategory}
        allCategories={categories}
      />

      <Pagination
        key={totalPages}
        count={totalPages}
        activePage={activePage}
        onClick={(page) => setActivePage(page)}
        onClickNext={() => setActivePage((prevState) => (prevState += 1))}
        onClickPrev={() => setActivePage((prevState) => (prevState -= 1))}
      />
      {isAddCategory && (
        <AddCategoryModal
          onClose={() => setIsAddCategory(false)}
          onApply={onClickApplyModal}
        />
      )}

      {editSelectedCategory && (
        <EditCategoryModal
          category={editSelectedCategory}
          onClose={() => setEditCategory(null)}
          onApply={onClickApplyModal}
          isInfo={isInfoModal}
        />
      )}
    </main>
  );
};

export default CategoriesPage;
